import { createAction, props } from '@ngrx/store';

// Just for reference - was taken from a console.log of a notification
export interface FirebaseNotificationPayload {
  from: string;
  priority: string;
  data: any;
  notification: {
    title: string;
    body: string;
  };
  collapseKey: string;
}

export const initializePush = createAction('[Push] Request Push Init');
export const pushInitSuccess = createAction('[Push] Push Init Success');
export const initializePushFailed = createAction(
  '[Push] Push Init Failure',
  props<{ error: any }>()
);
export const didReceiveNotification = createAction(
  '[Push] Receive Notification',
  props<{ title?: string; message?: string; payload?: FirebaseNotificationPayload }>()
);
export const notificationSubscriptionError = createAction(
  '[Push] Failed FCM Notification Subscription',
  props<{ error: any }>()
);
export const registerDevice = createAction(
  '[Push] Request Register Device',
  props<{ deviceToken: string }>()
);
export const successRegisterDevice = createAction('[Push] Register Device Success');
export const failRegisterDevice = createAction(
  '[Push] Register Device Failed',
  props<{ error: any }>()
);
